import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { addSpeciality } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";
import axios from "axios";
import Select from "react-select";

class AddSpeciality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      specialitytitle: "",
      specialitytitleError: null,
      speciality_icon_url: "",
      speciality_icon_urlError: null,
      speciality_description: "",
      speciality_descriptionError: null,
      oldspecialityIconfile: "",
      speciality_icon: "",
      speciality_icon_data: "",
      errormessages: [],
      speciality_icon_err: "",
      duration_error: "",
      duration: "",
      consultation_fee: "",
      consultation_feeError: "",
      chargeType: null,
      chargeTypeOptions: [
        { value: "paid", label: "Paid" },
        { value: "free", label: "Free" },
      ],
      chargeTypeError: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handlespeciality_iconFileChange =
      this.handlespeciality_iconFileChange.bind(this);
  }

  handlespeciality_iconFileChange(event) {
    var size = event.target.files[0].size;
    if (size > 2000000) {
      this.setState({
        speciality_icon_err: (
          <small className="text-danger">
            Image file size should be less than 2MB.
          </small>
        ),
      });
    } else {
      var file = event.target.files[0];
      var url = URL.createObjectURL(file);
      this.setState({
        speciality_icon: event.target.files[0],
        oldspecialityIconfile: url,
        speciality_icon_err: "",
      });
    }
  }

  uploadspeciality_icon() {
    document.getElementById("selectspeciality_icon").click();
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Speciality</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/speciality");
    }, 3000);
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    const re = /^\d*$/;

    if (name == "duration") {
      if (re.test(value) == true) {
        this.setState({
          [name]: value,
          duration_error: "",
        });
      }
    } else if (name == "consultation_fee") {
      const reNum = /^\d*\.?\d*$/;
      if (reNum.test(value) == true) {
        this.setState({
          [name]: value,
          consultation_feeError: "",
        });
      }
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    var titleError = "";
    var iconError = "";
    var durationerror = "";

    if (
      this.state.specialitytitle == "" ||
      this.state.specialitytitle == null
    ) {
      error = true;
      titleError = (
        <small className="text-danger">Speciality Title is required.</small>
      );
    }

    if (
      this.state.speciality_icon == "" ||
      this.state.speciality_icon == null
    ) {
      error = true;
      iconError = (
        <small className="text-danger">Please select speciality icon.</small>
      );
    }

    if (this.state.speciality_description == "") {
      error = true;
      this.setState({
        speciality_descriptionError: (
          <small className="text-danger">Description is required.</small>
        ),
      });
    } else {
      this.setState({ speciality_descriptionError: null });
    }

    if (this.state.duration == "" || this.state.duration == null) {
      error = true;
      durationerror = (
        <small className="text-danger">Please enter duration</small>
      );
    }

    if (this.state.chargeType == "" || this.state.chargeType == null) {
      error = true;
      this.setState({
        chargeTypeError: (
          <small className="text-danger">Please select charge type</small>
        ),
      });
    }

    if (error) {
      this.setState({
        specialitytitleError: titleError,
        speciality_icon_err: iconError,
        duration_error: durationerror,
      });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({ processing: true });
      const fdata = new FormData();
      fdata.append("speciality_icon", this.state.speciality_icon);
      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/specialities/icon";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          if (res.data.success == true) {
            addSpeciality(
              obj,
              this.state.specialitytitle,
              res.data.data.speciality_icon_url,
              this.state.speciality_description,
              this.state.duration,
              this.state.consultation_fee,
              this.state.chargeType.value
            )
              .then((res) => {
                if (res.success === false) {
                  var ermessage = [];
                  for (var key of Object.keys(res.data)) {
                    var data = res.data[key];
                    ermessage.push(data);
                  }
                  this.setState({ errormessages: ermessage });
                } else if (res.success === true) {
                  this.handleSuccess("bl");
                }
              })
              .catch((error) => {
                this.handleNetworkError("bl");
                console.log(error, "== error");
              });
          } else {
            var icondata = "";
            addSpeciality(
              obj,
              this.state.specialitytitle,
              icondata,
              this.state.speciality_description
            )
              .then((res) => {
                if (res.success === false) {
                  var ermessage = [];
                  for (var key of Object.keys(res.data)) {
                    var data = res.data[key];
                    ermessage.push(data);
                  }
                  this.setState({ errormessages: ermessage });
                } else if (res.success === true) {
                  this.handleSuccess("bl");
                }
              })
              .catch((error) => {
                this.handleNetworkError("bl");
              });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  }

  onChargeTypeChange = (value) => {
    this.setState({ chargeType: value, chargeTypeError: null });
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel>Speciality Title</ControlLabel>
                      <FormControl
                        name="grouptitle"
                        value={this.state.specialitytitle}
                        onChange={(event) => {
                          this.setState({
                            specialitytitle: event.target.value,
                          });
                          event.target.value === ""
                            ? this.setState({
                                specialitytitleError: (
                                  <small className="text-danger">
                                    Speciality title is required.
                                  </small>
                                ),
                              })
                            : this.setState({ specialitytitleError: null });
                        }}
                        placeholder="Enter Speciality Title"
                        type="text"
                      />
                      {this.state.specialitytitleError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Call Duration(In Minutes)</ControlLabel>
                      <FormControl
                        name="duration"
                        value={this.state.duration}
                        onChange={(event) => this.onChange(event)}
                        placeholder="Enter Duration"
                        type="text"
                      />
                      {this.state.duration_error}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Consultation Fee</ControlLabel>
                      <FormControl
                        name="consultation_fee"
                        value={this.state.consultation_fee}
                        onChange={(event) => this.onChange(event)}
                        placeholder="Enter Consultation Fee"
                        type="text"
                      />
                      {this.state.consultation_feeError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Charge Type</ControlLabel>
                      <Select
                        placeholder="Charge Type"
                        name="chargeType"
                        closeMenuOnSelect={true}
                        value={this.state.chargeType}
                        onChange={(value) => this.onChargeTypeChange(value)}
                        options={this.state.chargeTypeOptions}
                      />
                    </FormGroup>
                    {this.state.chargeTypeError}

                    <FormGroup>
                      <ControlLabel>Description</ControlLabel>
                      <textarea
                        name="speciality_description"
                        value={this.state.speciality_description}
                        onChange={(event) => {
                          this.setState({
                            speciality_description: event.target.value,
                          });
                        }}
                        className="form-control"
                        rows={5}
                        style={{ resize: "none" }}
                      ></textarea>
                    </FormGroup>
                    {this.state.speciality_descriptionError}

                    <FormGroup>
                      <ControlLabel>Speciality Icon</ControlLabel>
                      <br></br>

                      <input
                        style={{ display: "none" }}
                        id="selectspeciality_icon"
                        type="file"
                        className="form-control"
                        name="speciality_icon"
                        onChange={this.handlespeciality_iconFileChange}
                      />
                      <div className="specialityuploadicon">
                        <div className="previewwithbutton">
                          <Button
                            onClick={this.uploadspeciality_icon}
                            style={{ color: "#2B3A41", width: "fit-content" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.speciality_icon == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.speciality_icon == ""
                              ? "Choose Speciality Icon"
                              : "Change Speciality Icon"}
                          </Button>
                          {this.state.oldspecialityIconfile ? (
                            <>
                              <a
                                target="_blank"
                                href={this.state.oldspecialityIconfile}
                              >
                                <img
                                  src={this.state.oldspecialityIconfile}
                                  style={{
                                    height: "35px",
                                    width: "35px",
                                    border: "1px solid black",
                                    borderRadius: "50%",
                                    marginBottom: "3px",
                                  }}
                                ></img>
                              </a>
                              <br></br>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        {this.state.speciality_icon_err}
                      </div>
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AddSpeciality;
